import React, { FunctionComponent } from 'react'
import { UseQueryState } from 'urql/dist/types/hooks/useQuery'

import {
  AuctionMonitoringFilterState,
  AuctionMonitoringRecord,
} from '../../../common/auctionMonitoringTypes'
import { TABLE_VIEW } from '../../../common/foreclosureMonitoringTypes'
import {
  AuctionListingFilter,
  AuctionMonitoringTabQuery,
} from '../../../graphql/generated'
import { defaultViewParam } from '../../utils/paths'
import { monitoringViewSlug } from '../../utils/tabsHelpers'
import { useTabKeyState } from '../../utils/useTabKeyState'
import { MonitoringContentSuspense } from '../MonitoringContentSuspense/MonitoringContentSuspense'
import { PropertyMonitoringFetchError } from '../PropertyMonitoringFetchError/PropertyMonitoringFetchError'

const AuctionMonitoringTable = React.lazy(
  () => import('../AuctionMonitoringTable/AuctionMonitoringTable')
)
const AuctionMonitoringTiles = React.lazy(
  () => import('../AuctionMonitoringTiles/AuctionMonitoringTiles')
)

export interface AuctionMonitoringContentProps {
  dataSource?: UseQueryState<AuctionMonitoringTabQuery>
  filter?: AuctionMonitoringFilterState
  filterQuery?: AuctionListingFilter
}

export const AuctionMonitoringContent: FunctionComponent<AuctionMonitoringContentProps> =
  props => {
    const [viewType] = useTabKeyState<TABLE_VIEW>(
      TABLE_VIEW.TABLE,
      monitoringViewSlug,
      defaultViewParam
    )

    if (props.dataSource?.error)
      return <PropertyMonitoringFetchError type="dražeb" />

    return (
      <MonitoringContentSuspense>
        {viewType === TABLE_VIEW.TILES ? (
          <AuctionMonitoringTiles
            data={
              props.dataSource?.data?.allAuctionListings
                ?.nodes as unknown as AuctionMonitoringRecord[]
            }
          />
        ) : (
          <AuctionMonitoringTable
            viewType="page"
            filter={props.filter}
            auctionListingFilter={props.filterQuery}
            loading={props.dataSource?.fetching}
            data={
              props.dataSource?.data?.allAuctionListings
                ?.nodes as unknown as AuctionMonitoringRecord[]
            }
          />
        )}
      </MonitoringContentSuspense>
    )
  }
